import Button from 'react-bootstrap/Button';

const MobileLoadMoreFooter = ({ visibleCount, totalCount, itemLabel, onLoadMore, isLoading, hasMore }) => (
    <div className="discovery-mobile-load-more" aria-live="polite">
        <div className="discovery-mobile-load-more__count">
            {visibleCount} of {totalCount} {itemLabel}
        </div>
        {hasMore && (
            <Button
                type="button"
                variant="outline-secondary"
                className="btn-sm"
                onClick={onLoadMore}
                disabled={isLoading}
            >
                {isLoading ? 'Loading…' : `Load more ${itemLabel}`}
            </Button>
        )}
    </div>
);

export default MobileLoadMoreFooter;
